.progress-wrap {
  --gray: #dddddd;
  --black: #222222;
  background-color: white;
  position: fixed;
  right: 30px;
  bottom: 30px;
  height: 46px;
  width: 46px;
  cursor: pointer;
  display: block;
  border-radius: 50px;
  box-shadow: inset 0 0 0 2px var(--gray);
  z-index: 10000;
  opacity: 0;
  visibility: hidden;
  transform: translateY(15px);
  -webkit-transition: all 200ms linear;
  transition: all 200ms linear;

  .icon {
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: var(--black);
    transition: all 200ms linear;
  }

  &.active-progress {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }

  svg.progress-circle {
    width: 100%;

    path {
      fill: none;
      stroke: var(--black);
      stroke-width: 4;
      box-sizing: border-box;
      -webkit-transition: all 200ms linear;
      transition: all 200ms linear;
    }
  }

}
